import EXPIRYDOWNLOAD from "../../assets/download.svg";
import SALEABLEDOWNLOAD from "../../assets/download_2.svg";
import { getErrorToast } from "../../toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import './DownloadReport.css'

var fileDownload = require("js-file-download");

function formatDate(date) {
    var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [day, month, year].join("-");
}

const ExpirtReport = ({
    row, setClaimRecord
}) => {
    const axiosPrivate = useAxiosPrivate()

    const handleDownload = async () => {
        const id = row.stockists_master_id
        axiosPrivate
            .get(`/report/download-report/${id}`, {
                responseType: "blob",
            })
            .then((response) => {
                if (response.status === 200) {
                    let date = new Date();
                    fileDownload(
                        response.data,
                        `${row.party_master__name}_${row.party_master__customer}_Expiry_${formatDate(date)}.zip`
                    );
                    setClaimRecord((record) =>
                        record.map((current) =>
                            current.stockists_master_id === row.stockists_master_id
                                ? {
                                    ...current,
                                    indicator: {
                                        ...current.indicator,
                                        download_indigater_e: true
                                    }
                                }
                                : current
                        )
                    );
                }
            })
            .catch((error) => {
                if (error.response["status"] === 501) {
                    getErrorToast("No Expired Medicine in Claim", 1000);
                }
            });
    };

    return (
        <button
            onClick={handleDownload}
            className={
                row["indicator"]["download_indigater_e"] === true
                    ? "claim__buttion__green"
                    : "claim__buttion"
            }
        >
            <img src={EXPIRYDOWNLOAD} alt="Download Expiry" title="Expiry Download" />
        </button>
    )
}

const SaleableReport = ({
    row, setClaimRecord
}) => {
    const axiosPrivate = useAxiosPrivate()

    const handleDownload = async () => {
        const id = row.stockists_master_id
        axiosPrivate
            .get(`/report/download-saleable-report/${id}`, {
                responseType: "blob",
            })
            .then((response) => {
                if (response.status === 200) {
                    let date = new Date();
                    fileDownload(
                        response.data,
                        `${row.party_master__name}_${row.party_master__customer}_Salebale_${formatDate(date)}.zip`
                    );
                    setClaimRecord((record) =>
                        record.map((current) =>
                            current.stockists_master_id === row.stockists_master_id
                                ? {
                                    ...current,
                                    indicator: {
                                        ...current.indicator,
                                        download_indigater_s: true
                                    }
                                }
                                : current
                        )
                    );
                }
            })
            .catch((error) => {
                if (error.response["status"] === 501) {
                    getErrorToast("No Expired Medicine in Claim", 1000);
                }
            });
    };

    return (
        <button
            onClick={handleDownload}
            className={
                row["indicator"]["download_indigater_s"] === true
                    ? "claim__buttion__green"
                    : "claim__buttion"
            }
        >
            <img src={SALEABLEDOWNLOAD} alt="SALEABLE Expiry" title="SALEABLE Download" />
        </button>
    )
}

export { ExpirtReport, SaleableReport, formatDate }